import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	Freeze,
	Interactive,
	interpolate,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';

const TimelineClipSelectionCapture = () => {
	const {fps} = useVideoConfig();
	const frame = (useCurrentFrame() * 60) / fps;

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={(534 / 60) * fps}
			style={{
				width: 2560,
				height: 1410,
			}}
		>
			<Video
				muted
				src="https://remotion.media/studio-close-ups/timeline-clip-selection-retake-41ecd40971a4.mp4"
				durationInFrames={(534 / 60) * fps}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				// Keep the arrow while the marquee passes over clip trim handles.
				cursor="auto"
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 60, 386, 487, 495],
						[
							4.483485209205593, 4.035136688285034, 4.483485209205593,
							4.035136688285034, 4.483485209205593,
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							9, 10, 11, 18, 19, 20, 21, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35,
							36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 66, 67, 70, 71, 72, 73,
							74, 80, 81, 85, 86, 87, 92, 93, 99, 100, 105, 106, 112, 113, 139,
							140, 147, 148, 153, 154, 160, 161, 167, 168, 174, 175, 180, 181,
							186, 187, 193, 194, 200, 201, 207, 208, 217, 218, 225, 226, 233,
							234, 242, 243, 252, 253, 261, 262, 269, 270, 276, 277, 283, 284,
							290, 291, 298, 299, 306, 307, 314, 315, 321, 322, 327, 328, 336,
							337, 344, 345, 351, 352, 358, 359, 370, 371, 377, 378, 393, 394,
							426, 427, 428, 429, 430, 431, 432, 433, 434, 441, 442, 448, 449,
							455, 456, 462, 463, 468, 469, 470, 471, 472, 473, 476, 477, 478,
							479, 480, 481, 482, 483,
						],
						[
							'1555.051309416304px 1128.5772925047204px',
							'1555.051309416304px 1128.5772925047204px',
							'1889.6664203814682px 999.4143885285828px',
							'1889.6664203814682px 999.4143885285828px',
							'2157.186875735435px 1001.6386175190871px',
							'2185.173631064773px 1015.0890731467039px',
							'2212.2671920750895px 1028.4869879320252px',
							'2212.2671920750895px 1028.4869879320252px',
							'2239.0630216457325px 1032.6552280874587px',
							'2243.161207344772px 1031.639438469748px',
							'2244.2120241906796px 1031.3241934159757px',
							'2244.9475959828146px 1031.3241934159757px',
							'2247.084256902827px 1032.8478778425417px',
							'2253.2140218372874px 1038.9075883206085px',
							'2264.527816544892px 1048.4700216183674px',
							'2270.2547683550883px 1053.2862654954438px',
							'2273.547327805599px 1057.0341789125139px',
							'2275.4212845141337px 1061.0272829269627px',
							'2278.4511397531674px 1067.7525107407712px',
							'2282.8295432777822px 1075.528555400487px',
							'2286.629997537148px 1080.484908190351px',
							'2288.5740087020768px 1082.7791916372491px',
							'2288.731631228963px 1082.9718413923322px',
							'2288.731631228963px 1082.9718413923322px',
							'2288.8717401417507px 1083.11195030512px',
							'2289.7123936184767px 1083.6198451139753px',
							'2290.3779109542184px 1083.6198451139753px',
							'2290.3779109542184px 1083.6198451139753px',
							'2291.0259146758613px 1083.6198451139753px',
							'2291.0259146758613px 1083.6198451139753px',
							'2289.9750978299535px 1081.2555072106832px',
							'2287.4531373997756px 1075.335905645404px',
							'2285.719289604028px 1071.447883315546px',
							'2282.6894343649947px 1065.4056864515776px',
							'2282.6894343649947px 1065.4056864515776px',
							'2272.111211449525px 1021.9719234873984px',
							'2272.111211449525px 1021.9719234873984px',
							'2268.2757299619625px 963.966833593301px',
							'2268.2757299619625px 963.966833593301px',
							'2268.2757299619625px 963.966833593301px',
							'2267.032263360972px 891.8107435076485px',
							'2267.032263360972px 891.8107435076485px',
							'2266.734531921298px 834.6988479325726px',
							'2266.734531921298px 834.6988479325726px',
							'2265.245874722929px 817.3253427469009px',
							'2265.245874722929px 817.3253427469009px',
							'2264.405221246203px 815.4338724242673px',
							'2264.405221246203px 815.4338724242673px',
							'2264.405221246203px 815.3463043537749px',
							'2264.405221246203px 815.3463043537749px',
							'2236.418465916865px 814.0152696822921px',
							'2236.418465916865px 814.0152696822921px',
							'2195.4541225405687px 815.118627370495px',
							'2195.4541225405687px 815.118627370495px',
							'2130.0232602687242px 817.062638535424px',
							'2130.0232602687242px 817.062638535424px',
							'2052.7006540240263px 820.5128205128204px',
							'2052.7006540240263px 820.5128205128204px',
							'1805.3208548832881px 825.6267958295706px',
							'1805.3208548832881px 825.6267958295706px',
							'1696.8940699997263px 826.1697178666228px',
							'1696.8940699997263px 826.1697178666228px',
							'1629.238978737378px 829.2346003338532px',
							'1629.238978737378px 829.2346003338532px',
							'1588.1520400623922px 831.0385025859946px',
							'1588.1520400623922px 831.0385025859946px',
							'1556.6450482992639px 831.4588293243576px',
							'1556.6450482992639px 831.4588293243576px',
							'1501.1093779930493px 832.4220780997729px',
							'1501.1093779930493px 832.4220780997729px',
							'1435.2056481405466px 834.1559258955203px',
							'1435.2056481405466px 834.1559258955203px',
							'1385.537038557316px 834.6813343184741px',
							'1385.537038557316px 834.6813343184741px',
							'1347.4099006649699px 835.592042251594px',
							'1347.4099006649699px 835.592042251594px',
							'1276.1119776701419px 836.2925868155323px',
							'1276.1119776701419px 836.2925868155323px',
							'1192.537011192294px 836.5027501847138px',
							'1192.537011192294px 836.5027501847138px',
							'1099.5922611717701px 835.9598281476616px',
							'1099.5922611717701px 835.9598281476616px',
							'999.7121199682565px 835.9598281476616px',
							'999.7121199682565px 835.9598281476616px',
							'938.2218208685657px 836.6078318693046px',
							'938.2218208685657px 836.6078318693046px',
							'878.5354240210163px 836.6078318693046px',
							'878.5354240210163px 836.6078318693046px',
							'829.0769778069671px 836.6078318693046px',
							'829.0769778069671px 836.6078318693046px',
							'758.8824125003421px 836.6078318693046px',
							'758.8824125003421px 836.6078318693046px',
							'658.2842131187915px 835.3818788824125px',
							'658.2842131187915px 835.3818788824125px',
							'540.9254850450154px 834.8039296171634px',
							'540.9254850450154px 834.8039296171634px',
							'495.4776564595134px 834.068357825028px',
							'495.4776564595134px 834.068357825028px',
							'457.87592699012123px 833.5079221738773px',
							'457.87592699012123px 833.5079221738773px',
							'404.1441589360479px 832.3169964151821px',
							'404.1441589360479px 832.3169964151821px',
							'394.3015078127138px 832.0893194319021px',
							'394.3015078127138px 832.0893194319021px',
							'391.34170703007413px 831.5989382371453px',
							'391.34170703007413px 831.5989382371453px',
							'391.34170703007413px 831.4238020961607px',
							'391.34170703007413px 831.4238020961607px',
							'390.81629860712036px 831.4238020961607px',
							'390.81629860712036px 831.4238020961607px',
							'390.67618969433266px 831.4238020961607px',
							'390.67618969433266px 831.4238020961607px',
							'390.67618969433266px 832.0542922037052px',
							'390.67618969433266px 832.0542922037052px',
							'390.536080781545px 832.1768875023944px',
							'389.83553621760666px 833.0525682073173px',
							'388.5395287743207px 836.047396218154px',
							'387.76892975398846px 841.5291574309717px',
							'387.4011438579208px 851.7395944503735px',
							'385.7548641326656px 872.4406863147525px',
							'384.19615247790273px 903.0895109870563px',
							'383.89842103822895px 928.9396053963823px',
							'383.89842103822895px 928.9396053963823px',
							'387.1909804887393px 1245.375584927346px',
							'387.1909804887393px 1245.375584927346px',
							'455.35396655994305px 1323.4512765782777px',
							'455.35396655994305px 1323.4512765782777px',
							'770.2312344361437px 1287.705990203322px',
							'770.2312344361437px 1287.705990203322px',
							'1301.2440139014311px 1308.862436034261px',
							'1301.2440139014311px 1308.862436034261px',
							'1365.3088142735955px 1335.5006430780177px',
							'1365.8342226965492px 1340.1592644282077px',
							'1365.869249924746px 1345.238212516761px',
							'1365.869249924746px 1347.2347645239854px',
							'1365.869249924746px 1349.056180390225px',
							'1365.869249924746px 1349.056180390225px',
							'1365.0285964480202px 1349.056180390225px',
							'1362.769340229319px 1349.056180390225px',
							'1359.68694414799px 1349.056180390225px',
							'1352.9091754918861px 1349.056180390225px',
							'1349.7392113400651px 1349.056180390225px',
							'1349.6866704977697px 1349.056180390225px',
							'1349.4940207426866px 1349.056180390225px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};

const TimelineClipSelectionContent = ({
	rattleTiming,
}: {
	readonly rattleTiming: boolean;
}) => {
	const frame = useCurrentFrame();
	const {fps, width, height} = useVideoConfig();
	const portraitPan = rattleTiming && width < height;
	// The marquee starts on the right. Follow it left, then hold on the selected clips.
	const focusX = portraitPan
		? interpolate(frame / fps, [8 / 30, 36 / 30], [2140, 460], {
				easing: Easing.bezier(0.24, 0, 0.55, 1),
				extrapolateLeft: 'clamp',
				extrapolateRight: 'clamp',
			})
		: 1350;

	return (
		<AbsoluteFill showInTimeline={false} style={{backgroundColor: '#15161b'}}>
			<AbsoluteFill
				name="Clip selection - tilted camera"
				style={{
					width: 2560,
					height: 1410,
					left: '50%',
					top: '50%',
					translate: `${-focusX}px -825px`,
					transformOrigin: `${focusX}px 825px`,
					rotate: '-4deg',
					scale: portraitPan
						? height / 1280
						: 1.1 * Math.min(width / 2560, height / 1600),
				}}
			>
				<Freeze
					active={rattleTiming}
					frame={interpolate(
						frame,
						// Eight selection groups hit global frames 360–381, three frames
						// apart, then hold the final selection before the pointer moves away.
						// Use source seconds because the capture is variable-FPS.
						[
							0, 4, 5, 10, 11, 13, 14, 16, 17, 19, 20, 22, 23, 25, 26, 28, 29,
							31, 32, 35,
						].map((beatFrame) => (beatFrame / 30) * fps),
						[
							0.8, 0.98, 1.06, 1.38, 1.65, 1.92, 3.1, 3.15, 3.7, 3.8, 4.3, 4.4,
							4.7, 4.78, 5.2, 5.25, 5.4, 5.44, 5.6, 6.25,
						].map((sourceSeconds) => sourceSeconds * fps),
						{extrapolateLeft: 'clamp', extrapolateRight: 'clamp'},
					)}
				>
					<TimelineClipSelectionCapture />
				</Freeze>
			</AbsoluteFill>
		</AbsoluteFill>
	);
};

export const TimelineClipSelectionComposition = Interactive.create({
	Component: TimelineClipSelectionContent,
	layout: 'absolute-fill',
	schema: {
		...Interactive.backgroundSchema,
		rattleTiming: {
			type: 'boolean',
			default: false,
			description:
				'Match each selection burst to the opening rattle, then hold',
		},
	},
});
